/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ locale: NonNullable<unknown> }} Locale_LabelInputs */

const en_locale_label = /** @type {(inputs: Locale_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.locale === "en") return /** @type {LocalizedString} */ (`English`);
	if (i?.locale === "pt-BR") return /** @type {LocalizedString} */ (`Português (BR)`);
	return /** @type {LocalizedString} */ (`${i?.locale}`)
	
};

const pt_br2_locale_label = /** @type {(inputs: Locale_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.locale === "en") return /** @type {LocalizedString} */ (`English`);
	if (i?.locale === "pt-BR") return /** @type {LocalizedString} */ (`Português (BR)`);
	return /** @type {LocalizedString} */ (`${i?.locale}`)
	
};

/**
* | locale | output |
* | --- | --- |
* | "en" | "English" |
* | "pt-BR" | "Português (BR)" |
* | * | "{locale}" |
*
* @param {Locale_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const locale_label = /** @type {((inputs: Locale_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locale_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_locale_label(inputs)
	return pt_br2_locale_label(inputs)
});